import { render, staticRenderFns } from "./CreatePromotionBtn.vue?vue&type=template&id=5b3541bf"
import script from "./CreatePromotionBtn.vue?vue&type=script&lang=ts"
export * from "./CreatePromotionBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports